import { createStore } from 'vuex'
import { login } from '@/api/index'
import { ElMessage } from 'element-plus'
import router from '@/router'
import Cookies from 'js-cookie'
// import store from './store'

export default createStore({
  namespaced: true,
  state: {
    return: {
      token: '',
      userInfo: {}
    }
  },
  getters: {},
  mutations: {
    // 保存token
    setToken (state, token) {
      state.token = token
      Cookies.set('token', token)
    },

    // 保存到state里
    setUserInfo (state, obj) {
      state.userInfo = obj
    }
  },
  actions: {
    async login ({ commit }, token) {
      try {
        const res = await login(token)
        commit('setToken', res.data)
        // 登录成功才存token时间
        // commit('setTokenTime', Date.now())
        // 弹出成功的提示
        ElMessage.success('登录成功')
        // 成功就跳转了
        router.push('/')
      } catch {
        console.log('error')
      }
    }
  },
  modules: {}
})
